<template>
    <div class="container">
        <vue-headful title="ABL Groupe | CALVI" />
        <h2>CALVI</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../../assets/images/Etirefroid_Sipa.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Profilés spéciaux en aciers étirés à froid</h3>
                        <div>
                            Produits élaborés selon plan client dans une gamme de sections de 25 à 10 000 mm²
                            en longueurs de 2 à 13 m suivant poids métrique.
                        </div>
                        <div>
                            <p>Largeur : 6 à 180 mm</p>
                        </div>
                        <div>
                            <p>Epaisseur : 3 à 60 mm</p>
                        </div>
                        <div>
                            <p>Poids / mètre : 0,2 à 75 kg</p>
                        </div>
                        <h3>Cold drawn steel special sections</h3>
                        <div>
                            <div>Products manufactured according to customer drawing in a range of sections from 25 to 10 000 mm² in lengths from 2 up to 13 m depending on the metric weight. </div>
                        </div>
                        <div>
                            <p>Width : 6 up to 180 mm</p>
                        </div>
                        <div>
                            <p>Thickness : 3 up to 60 mm</p>
                        </div>
                        <div>
                            <p>Weight / meter : 0,2 up to  75 kg</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "CalviColddrawn"
    }
</script>

<style scoped>

</style>